// Local styles share the content-versioned bundle.
require('./common/components/UserAvatar/UserAvatar.css');
require('./styles.css');
require('./common/loadingSpinner/loadingSpinnerStyles.css');
require('./common/dialog/dialog.css');
require('./common/stepper/bmStepper.css');

// entry.js
//
// Webpack entry point. Mirrors what index.html used to load as individual
// <script> tags — same files, same order — bundled into a single bundle.js.
// Everything here registers itself onto the global `bizmetryApp` module
// defined in app.js (loaded first), matching AngularJS's classic
// script-tag-based bootstrapping.
//
// NOTE: landing/LandingController.js is required here so index.html's SPA
// route ('/' -> templateUrl: 'landing/landing.html') has LandingCtrl
// available. That same file is ALSO served standalone (unbundled) at
// /landing/LandingController.js for the landing page's own direct-access
// bootstrap — see webpack.config.js's CopyWebpackPlugin ignore list, which
// deliberately does NOT exclude landing/**/*.js for this reason.

require('./app.js');

require('./common/dialog/standard-dialog.js');
require('./common/ConfigurationService.js');
require('./common/PlatformInfoService.js');
require('./common/stepper/bmStepper.js');
require('./common/loadingSpinner/bmLoadingIndicator.js');
require('./common/loadingSpinner/LoadingHTTPInterceptor.js');
require('./common/loadingSpinner/LoadingService.js');
require('./common/components/GenericTypePill.js');
require('./common/filters.js');

require('./landing/LandingController.js');

require('./landing/PlatformContentController.js');
